const loaderCache: Record<string, Promise<void>> = {};

export enum LibCategories {
  strictlyNecessary = "C0001",
  performanceCookies = "C0002",
  functionalCookies = "C0003",
  targetingCookies = "C0004",
  socialMediaCookies = "C0005",
}

const SCRIPT_LOAD_ERROR_NAME = "ScriptLoadError";
export function isScriptLoadError(error: Error) {
  return error?.name === SCRIPT_LOAD_ERROR_NAME;
}

export function loadScript(
  src: string,
  // Start tagging. Filtering implementation to follow.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  categories: LibCategories[]
): Promise<void> {
  if (!loaderCache[src]) {
    loaderCache[src] = new Promise((resolve, reject) => {
      const script = document.createElement("script");

      // Before setting src
      script.onload = () => resolve();

      script.onerror = () => {
        const toThrow: any = new Error(`Failed to load script: ${src}`);
        toThrow.name = SCRIPT_LOAD_ERROR_NAME;
        toThrow.src = src;
        reject(toThrow);
      };

      script.async = true;

      // Do these last
      script.src = src;
      document.body.appendChild(script);
    });
  }
  return loaderCache[src];
}
